<style>
    .v-settings-menu .v-settings-menu-item {
        cursor: pointer;
    }

    .v-settings-menu .v-settings-menu-item:hover {
    }
</style>


<template>
    <div class="animated fadeIn v-settings-menu">
        <h5>{{Core.Definition.getDefinition('Paramètres')}}</h5>
        <hr/>
        <b-row>
            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/environnement'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-cogs font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Environnement')}}</h5>
                        <small>{{Core.Definition.getDefinition('Langue, timezone ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/commerce'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-shopping-cart font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Commerce')}}</h5>
                        <small>{{Core.Definition.getDefinition('Passerelle, devise, taxes, facturation ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/evenement'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="cui-calendar font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Événement')}}</h5>
                        <small>{{Core.Definition.getDefinition('Types disponibles, activation des lieux ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/messagerie'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-envelope-o font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Messagerie')}}</h5>
                        <small>{{Core.Definition.getDefinition('Courriel, apparence, SMS ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/notifications-automatiques'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-commenting font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Notifications automatiques')}}</h5>
                        <small>{{Core.Definition.getDefinition('Personnalisation du contenu, activation ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/reservations'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="cui-user-follow font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Réservations')}}</h5>
                        <small>{{Core.Definition.getDefinition('Paramètres de réservation ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/api'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-external-link font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('API')}}</h5>
                        <small>{{Core.Definition.getDefinition('Connexions API et accès ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/integrations'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-code font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Intégrations Widgets')}}</h5>
                        <small>{{Core.Definition.getDefinition('Apparence Widget, Injection CSS ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/apparence'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-eye font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Apparence')}}</h5>
                        <small>{{Core.Definition.getDefinition('Connexion, inscription, affichage des événements ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/classeur'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-archive font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Classeur')}}</h5>
                        <small>{{Core.Definition.getDefinition('Signatures, Étampes ...')}}</small>
                    </div>
                </div>
            </b-col>

            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/importations'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="fa fa-files-o font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Importations')}}</h5>
                        <small>{{Core.Definition.getDefinition('Utilisateurs, Abonnements ...')}}</small>
                    </div>
                </div>
            </b-col>

        </b-row>
        <hr/>
        <b-row>
            <b-col lg="3" md="4">
                <div @click="$router.push(Core.Definition.getDefinition('/systeme/parametres/compte-entreprise'))" class="card v-settings-menu-item">
                    <div class="card-body">
                        <div class="text-muted text-right mb-4">
                            <i class="cui-info font-2xl"></i>
                        </div>
                        <h5>{{Core.Definition.getDefinition('Compte entreprise')}}</h5>
                        <small>{{Core.Definition.getDefinition('Forfait, facturation Perfoplanning, paiement ...')}}</small>
                    </div>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))

    export default {
        name: 'SettingsMenu',
        components: {
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>
